module.exports = __webpack_public_path__ + "static/img/Corner-Hotel.7292ad0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Corner-Hotel.jpg
// module id = 2CXT
// module chunks = 0